<template>
  <div class="info">
    <div class="info-overlay">
      <div class="info_item">
        <img src="@/assets/img/clocks.svg" />
        <div class="text">
          <p>Комфортное время обучения</p>
          <span>Обучайтесь в режиме 24/7</span>
        </div>
      </div>
      <div class="info_item">
        <img src="@/assets/img/device.svg" />
        <div class="text">
          <p>Доступ с любых устройств</p>
          <span>Подключайтесь с телефона, планшета, компьютера</span>
        </div>
      </div>
      <div class="info_item">
        <img src="@/assets/img/house.svg" />
        <div class="text">
          <p>Занятия из дома</p>
          <span>Проходите курсы онлайн из любой точки мира</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Info'
}
</script>
